import * as React from 'react';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';

interface IPromoCodeInfoProps {
    promoCodeText: string;
    promoCodeTextTitle: string;
    promoCodeDescription: string;
    promoCodeRedirect: string;
    promoCodeText4: string;
    promoCodeText5: string;
    promoCodeText6: string;
}

class PromoCodeInfo extends React.Component<IPromoCodeInfoProps, any>{
    render() {
        const useTagInfo = '<use xlink:href="#icon-info" />';

        return (
            <div className="promo-code-info-container">
                <div className="promo-code-info-container-item">
                    <div className="promo-code-success-msg">
                        <svg className="promo-code-info" dangerouslySetInnerHTML={{ __html: useTagInfo }} />

                    </div>
                    <div className="rich-text">
                        <div className="promo-code-info-desc">{this.props.promoCodeText}</div>
                        <div className="promo-code-info-desc" dangerouslySetInnerHTML={{ __html: this.props.promoCodeTextTitle }}></div>
                        <div className="promo-code-info-desc" dangerouslySetInnerHTML={{ __html: this.props.promoCodeDescription }}></div>
                        <div className="promo-code-info-desc" dangerouslySetInnerHTML={{ __html: this.props.promoCodeRedirect }}></div>
                        <div className="promo-code-info-desc" dangerouslySetInnerHTML={{ __html: this.props.promoCodeText4 }}></div>
                        <div className="promo-code-info-desc" dangerouslySetInnerHTML={{ __html: this.props.promoCodeText5 }}></div>
                        <div className="promo-code-info-desc" dangerouslySetInnerHTML={{ __html: this.props.promoCodeText6 }}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PromoCodeInfo;